import React from 'react';
import useTealium from '../hooks/useTealium';
const withTealium = (WrappedComponent) => {
    return (props) => {
        const { trackEvent, trackView } = useTealium();
        return <WrappedComponent trackEvent={trackEvent} trackView={trackView} {...props}/>;
    };
};
export default withTealium;
